import React from 'react';
import './payment-details-card.scss';
import { isEmpty } from 'lodash';
import { FieldState } from '@zonofi/zono-money-store';
import { PaymentFieldKeys } from '../../constants';
import { HeaderCard } from '../../components';

interface PaymentDetailsCardProps {
  paymentDetails: FieldState[];
}

export const PaymentDetailsCard: React.FC<PaymentDetailsCardProps> = ({
  paymentDetails,
}) => {
  if (isEmpty(paymentDetails)) return null;

  const sortedPaymentDetails = [...paymentDetails].sort((a, b) => {
    if (a.label.toLowerCase() === PaymentFieldKeys.NARRATION) return 1;
    if (b.label.toLowerCase() === PaymentFieldKeys.NARRATION) return -1;
    return 0;
  });

  return (
    <div>
      <HeaderCard
        title={'PARSED PAYMENT DETAILS'}
        subtitle={
          'The information below is pre-populated from the uploaded image'
        }
      />
      <div className="payment-details-info-container">
        {sortedPaymentDetails?.map((item) => (
          <div key={item.key} className="payment-details-info-item">
            <span className="payment-details-info-container--label font-semibold">
              {item.label}
            </span>
            <span className="payment-details-info-container--value font-semibold">
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
